// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"914":"335d4800","1004":"6d24d4a8","3879":"c63e9c30","5523":"335d4800","6123":"a90004af","6749":"fde0f4c4","7315":"335d4800","7674":"e67f64e5"}[chunkId] + ".chunk.css";
};